import { IUserInfo } from 'globalCommon/services/getUserInfo';
import commonPageService from 'mCommon/services/commonPageService';
import { syncRender } from 'globalCommon/services/syncRender';
import './style.css';

function callback(userInfo: IUserInfo) {
    if (userInfo && userInfo.umu_id) {
        const freeuseList = document.getElementsByClassName('btn-freeuse');
        let index = freeuseList.length - 1;
        while (index >= 0) {
            freeuseList[index].remove();
            index--;
        }
    }
}

function init() {
    commonPageService({ cb: callback, renderAfter: syncRender });
}

init();
